<div  *ngIf="systemMessages.data$.value.length" class="nsc-system__message">
  <nsc-card class="nsc-card--error">
    <nsc-card-title-error title="System Messages"></nsc-card-title-error>
    <nsc-card-content>
      <div >
        <p *ngFor="let message of systemMessages.data$.value">
          <strong>{{ message.titleDescription }}</strong>: <span [innerHtml]="message.message | safeHtml:'html'"></span>
        </p>
      </div>
    </nsc-card-content>
  </nsc-card>

  <nsc-spacer size="md"></nsc-spacer>
</div>
